import { useBlocker } from "@tanstack/react-router";

/**
 * Navigation guard that blocks TanStack Router navigation when `shouldBlock` is true.
 *
 * Returns:
 *   - `showDialog`: true when navigation has been blocked and the confirm dialog should be shown
 *   - `onConfirmLeave`: call to proceed with navigation (leave the page)
 *   - `onCancelLeave`: call to cancel navigation (stay on the page)
 */
export function useNavigationGuard(shouldBlock: boolean) {
  const blocker = useBlocker({
    shouldBlockFn: () => shouldBlock,
    withResolver: true,
  });

  return {
    showDialog: blocker.status === "blocked",
    onConfirmLeave: () => blocker.proceed?.(),
    onCancelLeave: () => blocker.reset?.(),
  };
}
